export interface IDateConfig {
	output: string;
}
export const DateConfig: IDateConfig = {
	output: "dd/MM/yyyy"
};
